import "core-js/modules/es7.array.includes";
// Which environment the app runs in: 'dev' (quasar dev), 'test' (survey.greenmapper.org) or 'production'.
// Same test host check as the create-area debug menu (AreaMapStep.vue showMapDebugMenu).
export var TEST_HOSTS = ['survey.greenmapper.org']; // debug and demo panels (the yellow buttons) show only here (D74); the theme switcher in the account menu is not one

export var isDevEnvironment = function isDevEnvironment() {
  return appEnvironment() === 'dev';
};
export var appEnvironment = function appEnvironment() {
  if (process.env.DEV) return 'dev';
  var host = typeof window !== 'undefined' ? window.location.hostname : '';
  return TEST_HOSTS.includes(host) ? 'test' : 'production';
};